<template>
    <div class="px-2" :class="{ 'text-white' : isActive }">
        <font-awesome-icon icon="check-circle" v-if="isCompleted" class="mr-2" />

        <router-link :to="{ name: route }" v-if="route && isClickable" class="step-link" :class="{ 'text-white' : isActive }">
            {{ label }}
        </router-link>

        <template v-else>{{ label }}</template>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                required: true,
            },

            isCompleted: {
                type: Boolean,
                required: true,
            },

            isClickable: {
                type: Boolean,
                required: false,
            },

            isActive: {
                type: Boolean,
                required: true,
            },

            route: {
                type: String,
                required: false,
            },
        },
    };
</script>
